module.exports = __webpack_public_path__ + "media/images/icons/facilities/fireworks-free-e22289ab8d0fb2febaf6c2949fca8f97.svg";